<template>
<div>
    <div class="d-flex flex-row bd-highlight my-5 increase mx-auto">
  <div class=" bd-highlight border-bottom-0 off text-center pt-2">Review</div>
  <div class="bd-highlight border-top-0 border-left-0 offMe text-center pt-2">Write Review</div>
  <div class="bd-highlight col longer"></div>
</div>
<div class="rounded-pill pill pt-1 text-center">All(2k)</div>
</div>
</template>

<script>



export default {
    
    data () {
    return {
        
    }
  },
  
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/page3/bent.vue